import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { COLOR_GREY_12, COLOR_WHITE } from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledToolbarContainer = styled(Box)`
  ${flex({ fd: "row" })};
  position: absolute;
  top: calc(100% + 0.75rem);
  left: 50%;
  max-width: 300px;
  transform: translateX(-50%);
  width: max-content;
  min-width: 110px;
  color: ${COLOR_WHITE};
  font-size: 12px;
  background-color: ${COLOR_GREY_12};
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  z-index: 10;

  &::before {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 0.5rem;
    border-style: solid;
    border-color: transparent transparent ${COLOR_GREY_12} transparent;
  }
`;
